<script>
import { mapActions } from 'vuex'
import { format as formatDate, addYears } from 'date-fns'
import {
  appComputed,
  cartComputed,
  appMethods,
  cartMethods,
} from '@state/helpers'

const maxDate = addYears(new Date(), 1)

export default {
  data: () => ({
    checkInDate: '',
    checkOutDate: '',
    promotionCode: '',
    showPanel: false,
  }),
  computed: {
    ...appComputed,
    ...cartComputed,
    checkInPlaceholder() {
      return formatDate(new Date(this.checkInDate), 'DD MMM YYYY')
    },
    checkOutPlaceholder() {
      return formatDate(new Date(this.checkOutDate), 'DD MMM YYYY')
    },
    pickerOptions() {
      return {
        minDate: new Date(),
        singleDate: false,
        dropdowns: false,
        inline: true,
        maxDate,
        startDate: this.checkInPlaceholder,
        endDate: this.checkOutPlaceholder,
        onSelect: this.onSelect,
      }
    },
  },
  created() {
    this.checkInDate = this.checkIn
    this.checkOutDate = this.checkOut
    this.promotionCode = this.promoCode
  },
  methods: {
    ...appMethods,
    ...cartMethods,
    ...mapActions(['clearAllCart']),
    onSelect(startDate, endDate) {
      if (startDate) this.checkInDate = startDate.format('YYYY-MM-DD')
      if (endDate) this.checkOutDate = endDate.format('YYYY-MM-DD')
    },
    submit() {
      this.clearAllCart()
      this.$router.push({
        name: 'property-landing',
        query: {
          check_in: this.checkInDate,
          check_out: this.checkOutDate,
          promo_code: this.promotionCode,
        },
      })
    },
  },
}
</script>

<template>
  <div>
    <div
      class="flex md:hidden items-center text-center text-gray-600 leading-none"
    >
      <div class="w-1/2">
        <a class="block cursor-pointer" @click="showPanel = true">
          <span class="label">Check-in</span>
          <span class="block font-medium text-lg text-gold-500">
            {{ checkIn | formatDate('DD MMM YYYY') }}
          </span>
        </a>
      </div>

      <div class="mx-3">
        <i class="fas fa-arrow-right" />
      </div>

      <div class="w-1/2">
        <a class="block cursor-pointer" @click="showPanel = true">
          <span class="label">Check-out</span>
          <span class="block font-medium text-lg text-gold-500">
            {{ checkOut | formatDate('DD MMM YYYY') }}
          </span>
        </a>
      </div>
    </div>
    <Transition name="rise">
      <div
        v-show="showPanel"
        class="fixed h-screen max-h-screen inset-0 bg-gray-200 z-20"
      >
        <div class="relative py-4 px-3 border-b-2 border-gray-500 bg-white">
          <h4 class="font-medium">Choose your stay</h4>
          <button
            class="absolute right-0 top-0 px-3 py-4 cursor-pointer"
            @click="showPanel = false"
          >
            <i class="fas fa-times fa-lg"></i>
          </button>
        </div>
        <div class="px-3 h-full overflow-auto">
          <div class="my-3">
            <BaseDatepicker :options="pickerOptions" class="hidden" hidden />
          </div>
          <div class="-mx-3">
            <BaseInput v-model="promotionCode" label="Promo code" />
          </div>
          <div class="mb-20">
            <button
              class="btn btn-gold w-full"
              :class="{ 'btn-disabled': searching }"
              :disabled="searching"
              @click="submit"
            >
              {{
                $route.name === 'property-landing' ? 'Search' : 'Change dates'
              }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>
